import type { GrowthPayload } from './growthTypes';

/**
 * Growth reads the venues of the view context (decision 7.7.1): the server
 * builds the payload for exactly those venues, so nothing here narrows a
 * payload to some of its venues any more. Only the demo group keeps a local
 * picker of its fictional venues and brands, keyed with these values.
 */
export const GROWTH_FLEET_PROPERTY = 'fleet';

export function growthRestaurantIds(
  payload: GrowthPayload | null | undefined,
): string[] {
  if (payload?.viewSet?.length) return [...payload.viewSet];
  if (payload?.restaurants?.length) {
    return payload.restaurants.map(row => row.restaurantId).filter(Boolean);
  }
  return [];
}

// --- Demo brands (WP4.2) --------------------------------------------------

/** A named set of the demo group's venues, offered by the demo's own picker. */
export type GrowthBrand = { id: string; name: string; restaurantIds: string[] };

export const GROWTH_BRAND_PREFIX = 'brand:';

export function growthBrandKey(id: string): string {
  return `${GROWTH_BRAND_PREFIX}${id}`;
}
